import { api } from "..";

import { QueryProps } from "@/types/Api";

// Panel proxy for the whitelisted games-api config keys (see
// CASINO_CONFIG_FIELDS; sinek-api /games-admin/casino-config). Values travel in the API's
// NATIVE units; display-unit conversion lives in the CasinoConfig
// fields module, not here.

export interface CasinoConfigValue {
  category: string;
  key: string;
  value: number | null;
}

export const getCasinoConfig = async (
  props: QueryProps<void>
): Promise<CasinoConfigValue[]> => {
  const res = await api.client.get("/games-admin/casino-config", {
    signal: props.signal,
  });
  return res.data.values;
};

export interface UpdateCasinoConfigParams {
  category: string;
  key: string;
  value: number;
}

export const updateCasinoConfig = async (
  params: UpdateCasinoConfigParams
): Promise<CasinoConfigValue> => {
  const res = await api.client.put("/games-admin/casino-config", params);
  return res.data;
};
